import { GridCellProps } from '@progress/kendo-react-grid';
import GridCellBase from 'src/components/GridCellBase';

export const PeriodCell = (props: GridCellProps) => (
  <GridCellBase {...props} disableToolTip>
    <></>
  </GridCellBase>
);
